const ENDPOINTS = {
  STAGING: "https://system-ap-south-1-lb.acerp.api.beta.backend.acharyaerptech.in",
  PRODUCTION: "https://system-ap-south-1-lb.acerp.api.backend.acharyaerptech.in",
  DEV: "https://prashanth-ap-south-1-lb.acerp.api.devo.backend.acharyaerptech.in",
  LOCAL: "http://localhost:8080",
  TEST: "https://ganesh-ap-south-1-lb.acerp.api.devo.backend.acharyaerptech.in",
};

export const ENCRYPT_KEY = "YourSecretKey123";
export const CRM_ENCRYPT_KEY = "crm_auth_secret_key_789";

const FRONTEND_ENDPOINTS = {
  STAGING: "https://stage.preprodx.app/",
  PRODUCTION: "https://www.acharyaerptech.in/",
  DEV: "https://dev.preprodx.app/",
  LOCAL: "http://localhost:3000/",
  TEST: "https://test.preprodx.app",
};

const CRM_FRONTEND_DOMAIN = {
  STAGING: "https://crm.preprodx.app/",
  PRODUCTION: "https://www.flintme.in/",
  DEV: "https://crm.preprodx.app/",
  LOCAL: "https://crm.preprodx.app/",
};

const CRM_BACKEND_DOMAIN = {
  STAGING: "https://acharya-crm-dev-production.up.railway.app/api/v1",
  PRODUCTION: "https://system-ap-south-1-lb.accrm.api.backend.crm.flintme.in/api/v1",
  DEV: "https://acharya-crm-dev-production.up.railway.app/api/v1",
  LOCAL: "https://acharya-crm-dev-production.up.railway.app/api/v1",
};

const NEW_STUDENT_FRONTEND_DOMAIN = {
  STAGING: "https://staging.preprodx.app/",
  PRODUCTION: "https://student.acharyaerptech.in/",
  DEV: "https://devo.preprodx.app/",
  LOCAL: "http://localhost:3000/",
  TEST: "https://testing.preprodx.app/"
};

const NEW_FACULTY_FRONTEND_DOMAIN = {
  STAGING: "https://staging.preprodx.app/",
  PRODUCTION: "https://faculty.acharyaerptech.in/",
  DEV: "https://devo.preprodx.app/",
  LOCAL: "http://localhost:3000/",
  TEST: "https://testing.preprodx.app/"
};

const NEW_PG_FRONTEND_DOMAIN = {
  STAGING: "https://staging.preprodx.app/",
  PRODUCTION: "https://pg.acharyaerptech.in/",
  DEV: "https://devo.preprodx.app/",
  LOCAL: "http://localhost:3000/",
  TEST: "https://testing.preprodx.app/"
};

const CURRENT_ENV = process.env.REACT_APP_ENVIRONMENT || "DEV";
export const newFacultyUrl = NEW_FACULTY_FRONTEND_DOMAIN[CURRENT_ENV];
export const newStudentUrl = NEW_STUDENT_FRONTEND_DOMAIN[CURRENT_ENV];
export const newPgUrl = NEW_PG_FRONTEND_DOMAIN[CURRENT_ENV];
export const crmUrl = CRM_FRONTEND_DOMAIN[CURRENT_ENV];
export const crmBackendUrl = CRM_BACKEND_DOMAIN[CURRENT_ENV];

export const apiUrl = ENDPOINTS[CURRENT_ENV];

const domainUrl = FRONTEND_ENDPOINTS[CURRENT_ENV];

export const newStudentFrontEndDomainUrl =
  NEW_STUDENT_FRONTEND_DOMAIN[CURRENT_ENV];

export const newFacultyFrontEndDomainUrl =
  NEW_FACULTY_FRONTEND_DOMAIN[CURRENT_ENV];

export const newPgFrontEndDomainUrl = NEW_PG_FRONTEND_DOMAIN[CURRENT_ENV];

export default domainUrl;

// Kubernetes
// const domainUrl = "https://kube-pub-acharya-au-frontend-1287324227.ap-south-1.elb.amazonaws.com/";

// Custom Colors For Calendar
export const customColors = [
  //   "#6B793E",
  //   "#A9B179",
  //   "#D4D6AD",
  //   "#FEFAE0",
  //   "#F8DCC3",
  //   "F0AF94",
  //   "#C08769",
  //   "#8F5F3D",
  //   "#A15751",
  //   "#B8746A",
  //   "#C88D74",
  //   "#71513A",
  //   "#5B412A",
  //   "#92785B",
  //   "#451a2b",
  //   "#4b6043",
  //   "#3d251e",
  //   "#1d1717",
  //   "#D4F3B7",
  //   "#607d8b",
  //   "#562637",
  //   "#658354",
  //   "#4c3228",
  //   "#BFDAA4",
  //   "#673140",
  //   "#5b3e31",
  //   "#cfd8dc",
  //   "#87ab69",
  //   "#6a4a3a",
  //   "#716868",
  //   "#b0bec5",
  //   "#854553",
  //   "#999090",
  //   "#78909c",
  //   "#9a606c",
  //   "#8b6c5c",
  //   "#607d8b",
  //   "#af7b85",
  //   "#a08679",
  //   "#ded4d4",
  //   "#455a64",
  //   "#cc9fa8",
  //   "#c7ddb5",
  //   "#efe5e5",
  //   "#667558",
  //   "#37474f",
  //   "#eac3c9",
  //   "#ddead1",
  //   "#d8cbc4",
  //   "#fff6f6",
  //   "#263238",
  //   "#505C45",
  //   "#A15751",
  //   "#B8746A",
  //   "#C88D7A",
  //   "#71513A",
  //   "#5B412A",
  //   "#92785B",
  //   "#7F6749",
  //   "#AF957D",
  //   "#BEA48B",
  //   "#A0876A",
  //   "#45331D",
  //   "#D3AD7D",
  //   "#CEB797",
  //   "#D7C6AC",
  //   "#302310",
  //   "#665F4D",
  //   "#584F3F",
  //   "#77705E",
  //   "#474336",
  //   "#1D1A09",
  //   "#858270",
  //   "#37392E",
  //   "#949884",
  //   "#D6D8CB",
  //   "#2C2E23",
  //   "#C5CAC1",
  //   "#42473F",
  //   "#0CA07",
  //   "#1b2e35",
  //   "#2c434b",
  //   "#395660",
  //   "#476a75",
  //   "#527986",
  //   "#6c8c98",
  //   "#85a1ab",
  //   "#a7bcc3",
  //   "#c7d7dc",
  // "#94bfac",
  // "#5f88c1",
  // "#bbc9a5",
  // "#96bf65",
  // "#6b6f5a",
  // "#fdd906",
  // "#f6c870",
  // "#e8c88f",
  // "#f3d163",
  // "#c98a71",
  // "#9aaa9f",
  // "#c9a8ce",
  // "#f2e428",r
  // "#FBCBF2",
  // "#E9D7FA",
  // "#BAA7BF",
  // "#KM4454",
  // "#DBAAC",
  // "#DABBED",
  // "#93AECA",
  // "#CDE4DE",
  // "#FCDCD3",
  // "#B1A0CE",
  // "#D3C4BE",
  // "#E4DAC2",
  // "#DDD8D0",
  // "#B7A74B",
  // "#f6d85f",
  // "#ADB5D6",
  // "#C7D86F",
  // "#824D69",r
  // "#677E8A",
  // "#C9ADA7",
  // "#DFB6A2",
  // "#BDAC96",
  // "#6587A1",
  // "#C96480",
  // "#358A97",
  // "#289CBE",
  // "#2FC4B2",
  // "#ac715b",
  // "#c18a75",
  // "#dca998",
  // "#c2cc37",
  // "#cfde3d",
  // "#ff7045",r
  // "#ff8a66",r
  // "#b39ddb",
  // "#4DB6AC",
  // "#26A69A",
  // "#00BCD4",
  // "#00097A7",
  // "#81D4FA",
  // "#ffb74d",
  // "#ffa726",
  // "#ffab40",
  // "#ffe082",
  // "#ffd54f",
  // "#ffca28",r
  // "#ffc400",
  // "#ffee58",
  // "#ffeb3b",
  // "#ffea00",
  // "#ffd600",
  // "#FFCC80",
  // "#FFB74D",
  // "#F48FB1",
  // "#F06292",
  // "#9A99F2",
  // "#8B79D9",
  // "#B5E48C",
  // "#34A0A4",
  // "#74AF86",
  // "#399185",
  // "#7D7FB4",
  // "#9D98F6",
  // "#D59DE5",
  // "#F4A9D3",
  // "#F6BFBF",Latest
  // "#FBD4C0",
  // "#F8E1CD",
  // "#F9D69E",
  // "#DDD8FF",
  // "#D6EEFC",
  // "#F6F1EE",
  // "#F6E6CB",
  // "#FDF8E6",
  // "#F9DFE8",
  // "#EADEC6",
  // "#B4CFB1",
  // "#F0DAC9",
  // "#F7D1C8",
  // "#E1EDCC",
  // "#E8E4CB",
  // "#D9F7CD",
  // "#E7D7D6",
  // "#F8E8F3",
  // "#F8E8F3",
  // "#KM4457",
  // "#fffde7",
  // "#fff9c4",
  // "#fff59d",
  // "#ffe57f",
  // "#ffecb3",
  // "#ffd180",
  // "#ffcc80",
  // "#ffe0b2",
  // "#CCDCFF",
  // "#9EABC9",
  // "#E2DCDE",
  // "#C2CCBF",
  // "#97BE98",
  // "#FFBCCA",
  // "#FFD2CD",
  // "#DBD4C6",
  // "#DBD2C9",
  // "#CCD2CC",
  // "#A9B7AA",
  // "#dde878",
  "#8DE5DB",
  "#B2FOE8",
  // "#e7ef9e",
  "#D6AD98",
  "#E6CBA8",
  // "#FCDCB1",
  // "#FCF5DC",
  "#AECCA5",
  "#D9E3B1",
  // "#f1f5c4",
  "#904C77",
  "#E49AB0",
  "#ECB8A5",
  "#809bce",
  "#9cadce",
  "#d4afb9",
  // "#ff686b",
  "#68b6ef",
  // "#ff7477",
  "#f6ac69",
  "#f55c7a",
  "#f68c70",
  "#dab894",
  "#9b8bf4",
  "#FFC7C7",
  "#A39BD1",
  "#ac988f",
  "#937171",
  "#D8B7A5",
  "#ABD45C",
];

export const FEE_RECEIPT_DETAILS_PDF = "FeeReceiptDetailsPDF";

export const FEE_RECEIPT_SEARCH = "/receipts";

export const HOSTEL_FEE_PDF = "HostelFeePdf";

export const EXAM_RECEIPT_PDF = "ExamReceiptPdf";

export const BULK_FEE_RECEIPT_PDF = "BulkFeeReceiptPdf";

export const TRANSACTION_TYPE = {
  1: "Registration",
  2: "Bulk",
  3: "College",
  4: "Exam",
};

export const MONTH_LIST_OPTION = [
  {
    label: "January",
    value: 1,
  },
  {
    label: "February",
    value: 2,
  },
  {
    label: "March",
    value: 3,
  },
  {
    label: "April",
    value: 4,
  },
  {
    label: "May",
    value: 5,
  },
  {
    label: "June",
    value: 6,
  },
  {
    label: "July",
    value: 7,
  },
  {
    label: "August",
    value: 8,
  },
  {
    label: "September",
    value: 9,
  },
  {
    label: "October",
    value: 10,
  },
  {
    label: "November",
    value: 11,
  },
  {
    label: "December",
    value: 12,
  },
];
